import { STATUS_BADGE_CLASS, STATUS_LABEL } from "@/lib/constants";

export function StatusBadge({ status }) {
  const cls = STATUS_BADGE_CLASS[status] || "bg-slate-200 text-slate-700 border-slate-300";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {STATUS_LABEL[status] || status}
    </span>
  );
}
